import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ExerciseActivityTargetForm from '../../../components/forms/ExerciseActivityTargetForm';
import { useExerciseActivityTargetApi } from '../../../hooks/useExerciseActivityTargetApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ExerciseActivityTargetDTO } from '../../../services/apiClient';

const ExerciseActivityTargetEdit: React.FC = () => {
  const { getById, edit, isLoading } = useExerciseActivityTargetApi();
  const [entityData, setEntityData] = useState<ExerciseActivityTargetDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Exercise Activity Targets', href: '/admin/exerciseactivitytargets' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Exercise Activity Target data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/exerciseactivitytargets');
    } catch (error) {
      console.error('Error updating Exercise Activity Target:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/exerciseactivitytargets"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ExerciseActivityTarget.Edit'
    >
        {entityData ? (
          <ExerciseActivityTargetForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/exerciseactivitytargets')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default ExerciseActivityTargetEdit;